<template>
    <SignIn></SignIn>
    <FindGame v-if="status === EStatus.Undefined && connected"></FindGame>
    <Approve v-else-if="status === EStatus.Approve && connected" ></Approve>
    <Board v-else-if="status === EStatus.InProgress && connected" ></Board>
</template>

<script setup>
import SignIn from './SignIn.vue';
import FindGame from './FindGame.vue';
import Approve from './Approve.vue';
import Board from './Board.vue';
import { geks } from '../composables/geks'
const { connected, status, EStatus} = geks()

</script>